/*------------------------------------------
 * BLOCKS: Export Blocks JS
 *------------------------------------------*/

// Import Blocks JS Files
import { ProductSwiper } from "./block-product-swiper/_block-product-swiper.js";
import { InteractiveColumns } from "./block-interactive-columns/_block-interactive-columns.js";
import { Counter } from "./block-counter/_block-counter.js";
import { TeamGrid } from "./block-team/_block-team.js";

//-------------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", () => {
  /*--- Initialise imported blocks --- */


    // Initialise all ProductSwiper blocks
    document.querySelectorAll(".block-product-swiper").forEach(block => {
    new ProductSwiper(block);
});



    // Initialise all InteractiveColumns blocks
    document.querySelectorAll(".block-interactive-columns").forEach(block => {
    new InteractiveColumns(block);
});


  // Initialise all Counter blocks
  document.querySelectorAll(".block-counter").forEach((block) => {
    new Counter(block);
  });

  // Initialise all Team Grid blocks
  document.querySelectorAll(".block-team").forEach((block) => {
    new TeamGrid(block);
  });
});
